import App from '@/models/App'

export default class TrafficAccount extends App {
    static get entity() {
        return 'TrafficAccounts'
    }

    static one() {
        return this.query().withAllRecursive().first()
    }

    static all() {
        return this.query().orderBy('createdAt', 'desc').get()
    }

    static fields() {
        return {
            id: this.attr(''),
            traffic_organization_id: this.attr(''),
            type: this.attr(''),
            possibleNumberOfShipRegistration: this.attr(0),
            user: this.attr({}),
            organizationTrafficDetail: this.attr({}),
        }
    }

    static apiConfig = {
        actions: {
            getMine() {
                return this.get(`traffic/accounts/mine`, {
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
            fetch() {
                return this.get(`traffic/accounts`, {
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
            add(params) {
                return this.post(`traffic/accounts/add`, App.post(params), {
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    baseURL: App.apiURL(),
                })
            },
            update(trafficAccountId, params) {
                return this.patch(
                    `traffic/accounts/${trafficAccountId}`,
                    App.patch(params),
                    {
                        headers: {
                            Authorization: 'Bearer ' + App.apiToken(),
                            'Accept-Language': App.acceptLanguage(),
                        },
                        baseURL: App.apiURL(),
                    }
                )
            },
            destroy(trafficAccountId) {
                return this.delete(`traffic/accounts/${trafficAccountId}`, {
                    headers: {
                        Authorization: 'Bearer ' + App.apiToken(),
                        'Accept-Language': App.acceptLanguage(),
                    },
                    baseURL: App.apiURL(),
                    delete: trafficAccountId,
                })
            },
        },
    }
}
